import styled from "styled-components";

import { DESKTOP_BREAKPOINT } from "../../components/AppShell/styles";
import { FormGroup } from "../../components/Form/styles";

const MOBILE = `not all and (min-width: ${DESKTOP_BREAKPOINT})`;

export const Container = styled.div`
  padding-bottom: 2rem;
`;

/* A titled block of the screen: small uppercase label + card */
export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1.5rem 2rem 0;

  @media ${MOBILE} {
    padding: 20px 20px 0;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 20px;
  background: var(--color-neutral-dark);
  border-radius: 1rem;

  .divider {
    height: 1px;
    background: var(--color-neutral-base);
  }

  /* The card's gap already spaces the fields */
  ${FormGroup} {
    margin-bottom: 0;
  }
`;

export const ToggleRow = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;

  .text {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    min-width: 0;
  }

  .label {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }

  /* The PLUS tag of a locked option: opens the PLUS offer, brightens on hover */
  .plus {
    display: flex;
    transition: filter 0.15s;

    &:hover {
      filter: brightness(1.25);
    }
  }

  .description {
    font-size: 0.75rem;
    line-height: 1rem;
    color: var(--color-neutral-150);
  }

  /* The toggle's label is sized by its absolutely positioned track: give it the track's
     box so it centers in the row, and drop the margin meant for stacked forms */
  > label {
    flex-shrink: 0;
    width: 40px;
    height: 24px;
    padding: 0;
    margin: 0;

    /* The default "off" track is the card's own color: make it visible on the card */
    input:not(:checked) ~ span {
      background-color: var(--color-neutral-base);
    }
  }
`;

export const RemoveLink = styled.button`
  align-self: flex-start;
  margin: 2rem 2rem 0;
  font-family: Inter, sans-serif;
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--color-feedback-danger);

  &:hover {
    text-decoration: underline;
  }

  @media ${MOBILE} {
    margin: 1.5rem 20px 0;
  }
`;

/* Save/discard for the fields above, right-aligned at the bottom of the card */
export const CardFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: flex-end;
  padding-top: 1rem;
  border-top: 1px solid var(--color-neutral-base);

  .error {
    align-self: stretch;
    font-size: 0.75rem;
    color: var(--color-feedback-danger);
  }

  .actions {
    display: flex;
    gap: 1.25rem;
    align-items: center;
  }
`;

/* Shortcut to the PLUS subscription: same green glow as the other PLUS blocks */
export const SubscriptionCard = styled.button`
  display: flex;
  gap: 1rem;
  align-items: center;
  width: 100%;
  padding: 20px;
  text-align: left;
  background:
    radial-gradient(120% 140% at 0% 0%, rgba(87, 242, 139, 0.2) 0%, rgba(87, 242, 139, 0) 60%),
    var(--color-neutral-dark);
  border-radius: 1rem;
  box-shadow: inset 0 0 0 1px rgba(87, 242, 139, 0.25);
  transition: filter 0.15s;

  &:hover {
    filter: brightness(1.1);
  }

  .text {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.375rem;
    align-items: flex-start;
    min-width: 0;
  }

  .title {
    font-family: Inter, sans-serif;
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1.25rem;
    color: var(--color-neutral-white);
  }

  .description {
    font-family: Inter, sans-serif;
    font-size: 0.75rem;
    line-height: 1rem;
    color: var(--color-neutral-150);
  }

  .chevron {
    display: flex;
    flex-shrink: 0;
    color: var(--color-brand-plus);
  }
`;
